'use client';

import type { Transition } from 'motion/react';
import { motion, useAnimation } from 'motion/react';
import { useEffect } from 'react';

import { cn } from '@/lib/utils';

type ChevronUpIconProps = {
  className?: string;
  size?: number;
  isAnimating?: boolean;
};

const defaultTransition: Transition = {
  times: [0, 0.4, 1],
  duration: 0.5,
};

const ChevronUpIcon = ({
  className,
  size = 16,
  isAnimating,
}: ChevronUpIconProps) => {
  const controls = useAnimation();

  useEffect(() => {
    if (isAnimating) {
      controls.start('animate');
    } else {
      controls.start('normal');
    }
  }, [isAnimating, controls]);

  return (
    <svg
      aria-label='Chevron Up Icon'
      className={cn(className)}
      fill='none'
      height={size}
      role='img'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <motion.path
        animate={controls}
        d='m18 15-6-6-6 6'
        transition={defaultTransition}
        variants={{
          normal: { y: 0 },
          animate: { y: [0, -2, 0] },
        }}
      />
    </svg>
  );
};

ChevronUpIcon.displayName = 'ChevronUpIcon';

export { ChevronUpIcon };
